const info = {
  ZH: {
    //中文翻译
    title: "\u6750\u6599",
    type: "\u7C7B\u578B",
    cid: "ID",
    cver: "\u7248\u672C",
    enterprise: "\u521B\u5EFA\u4F01\u4E1A",
    cname: "\u6750\u6599\u540D\u79F0",
    cfrname: "\u6750\u6599\u540D\u79F0(\u5916\u6587)",
    csymbol: "\u6750\u6599\u53F7",
    ctradename: "\u5546\u54C1\u540D",
    class: "\u6750\u6599\u5206\u7C7B",
    extraclass: "\u989D\u5916\u5206\u7C7B",
    cmatFlag: "\u6750\u6599\u4EE3\u53F7/\u6807\u8BC6",
    cmatFlagRefStd:
      "\u6750\u6599\u4EE3\u53F7/\u6807\u8BC6\u5F15\u7528\u6807\u51C6",
    cinternalCode: "\u6750\u6599\u4EE3\u53F7",
    citnCodeStd: "\u6750\u6599\u4EE3\u53F7\u5F15\u7528\u6807\u51C6",
    creuseRate: "\u53EF\u518D\u5229\u7528\u7387",
    crecycleRate: "\u53EF\u56DE\u6536\u5229\u7528\u7387",
    cremark: "\u5907\u6CE8",
    recycledmaterials: "\u518D\u5FAA\u73AF\u6750\u6599",
    recycledmaterialsYes: "\u662F",
    recycledmaterialPostIndustrial:
      "\u4ECE\u5DE5\u4E1A\u5E9F\u6599\u4E2D\u56DE\u6536",
    recycledmaterialMaxRate: "\u6700\u5927\u503C",
    recycledmaterialConsumerrecyclate:
      "\u4ECE\u5E9F\u65E7\u6750\u6599\u4E2D\u56DE\u6536",
    recycledmaterialMinRate: "\u6700\u5C0F\u503C",
    recycledmaterialRange: "(\u8303\u56F4\u503C)",
    recycledmaterialRISO: "\u89C1 GB/T 24021",
    recycledmaterialsNo: "\u5426",
    recycledmaterialsTitle:
      "\u8BE5\u6750\u6599\u662F\u5426\u542B\u6709\u518D\u5FAA\u73AF\u6750\u6599",
    recycledmaterialsTips:
      "\u751F\u4EA7\u8FC7\u7A0B\u4E2D\u8F6C\u79FB\u51FA\u5E9F\u7269\u6D41\u7684\u6750\u6599\uFF0C\u4F46\u4E0D\u5305\u62EC\u540C\u4E00\u8FC7\u7A0B\u4E2D\u88AB\u518D\u5229\u7528\u7684\u6750\u6599\uFF0C\u5982\u901A\u8FC7\u518D\u52A0\u5DE5\u3001\u518D\u7814\u78E8\u6216\u5728\u540C\u4E00\u8FC7\u7A0B\u4E2D\u53C8\u88AB\u56DE\u6536\u7684\u6B8B\u6599\u3002",
    recycledmaterialsConsumerTips:
      "\u5BB6\u5EAD\u6216\u5546\u4E1A\u3001\u5DE5\u4E1A\u6216\u5176\u4ED6\u56E2\u4F53\u4F5C\u4E3A\u4EA7\u54C1\u7684\u6700\u7EC8\u7528\u6237\u6240\u4EA7\u751F\u7684\uFF0C\u65E0\u6CD5\u5728\u7528\u4E8E\u539F\u7528\u9014\u7684\u6750\u6599\uFF0C\u5305\u62EC\u4ECE\u9500\u552E\u94FE\u4E0A\u8FD4\u56DE\u7684\u6750\u6599\u3002",
    sample: "\u521d\u7248",
    checkReportNo: "\u68C0\u6D4B\u62A5\u544A\u7F16\u53F7",
    recycledmaterialsDna: "还没答复",
    recycleSourceEnterprise:
      " \u518D\u751F\u6750\u6599\u6765\u6E90\u4F01\u4E1A",
    createMaterial: "创建材料",
    modifyMaterial: "修改材料",
    msg: "本材料可能已经存在于 CAMDS 中。如果您不能确定, 可以转至材料查找。",
    msg1: "\u6750\u6599\u5206\u7c7b1.2/5.4/5.5.1/8.x\u4e0d\u652f\u6301\u5411imds\u8fdb\u884c\u6570\u636e\u8f6c\u6362\u3002",
    selectMaterClass: "选择材料分类",
    recycledMaterials1: "该物质含有再生材料吗?",
    recycledMaterials2: "机械（消费前）",
    recycledMaterials3: "机械（消费后）",
    recycledMaterials4: "化学（消费前）",
    recycledMaterials5: "化学（消费后）",
    recycledMaterials6: "根据下列标准认证",
    recycledMaterials7: "该材料是（部分）生物基的吗？",
    recycledMaterials8: "次级生物基材料的含量",
    recycledMaterials9: "根据下列标准认证",
    dRecycledMaterials1: "材料来源，包括循环材料",
    dRecycledMaterials2:
      "这里输入的所有数值是指整个材料，而不仅仅是指聚合物的含量。例如，在填充聚合物的情况下，只有当填充材料也是100%的回收材料时，回收材料的含量才能达到100%。",
    dRecycledMaterials3: "无机或化石材料的含量",
    dRecycledMaterials4: "主要无机或化石类物质的含量",
    dRecycledMaterials5: "回收物含量",
    dRecycledMaterials5_1: "其中机械回收物的含量",
    dRecycledMaterials5_1_1: "其中消费前回收物的含量",
    dRecycledMaterials5_1_2: "其中消费后回收物的含量",
    dRecycledMaterials5_2: "其中化学回收物的含量",
    dRecycledMaterials5_2_1: "其中消费前回收物的含量",
    dRecycledMaterials5_2_2: "其中消费后回收物的含量",
    dRecycledMaterials5_2_3: "根据下列标准认证",
    dRecycledMaterials5_2_4: "质量均衡的",
    dRecycledMaterials5_2_5: "不是质量均衡的",
    dRecycledMaterials5_3: "根据下列标准认证",
    dRecycledMaterials6: "生物基材料的含量",
    dRecycledMaterials6_1: "主要生物基材料的含量",
    dRecycledMaterials6_2: "次级生物基材料的含量",
    dRecycledMaterials6_3: "根据下列标准认证",
    tooltips1: "基于无机物的材料含量，如矿石和矿物或化石燃料（如矿物油）。",
    tooltips2:
      "这种回收技术通过机械和物理过程回收收集的废物，通常是分类、研磨、洗涤、分离材料、干燥和重新结晶，以产生保留所收集的废物材料的化学特性的材料输入。",
    tooltips3:
      "在生产过程中从废物流中转移出来的预消费回收物。不包括材料的再利用，如返工、再研磨或在一个过程中产生的废料，并且能够在产生该废料的同一过程中回收。<p></p> ",
    tooltips4:
      "消费后回收物是由家庭或商业、工业和机构设施产生的，他们作为产品的最终用户，不能再用于其预期目的。这包括从分销链中退回的材料。<p></p>(请参考第3.1.3章消费后回收物（PCR）和3.1.5章根据EN 45557标准对ISO 14021的解释）。",
    tooltips5:
      "通过裂解（热解）、气化或解聚改变废物流的化学结构，将其转化为单体或生产新原料，不包括能源回收和焚烧。",
    tooltips6:
      "在生产过程中从废物流中转移出来的预消费回收物。不包括材料的再利用，如返工、再研磨或在一个过程中产生的废料，并且能够在产生该废料的同一过程中回收。 <p></p> ",
    tooltips7: `
    质量平衡是一种保管链方法，用于说明进入和离开系统的材料。例如，在化学工业中，可再生或回收原料在连续操作的生产过程中与化石原料混合，并在发生化学转化后转化为特定的最终产品。输入和输出材料之间存在物理联系，这是现有认证方案的一个关键特征（与“账簿和索赔”相比也是如此）。
<p></p>包括质量平衡在内的监管链模型的基本定义在ISO 22095标准中描述。一个额外的ISO标准正在制定中，其目标是描述更多的细节并澄清与 "账簿和索赔 "的确切区别（预计将在2025/2026年生效）。
<p></p>关于分配，化工行业更倾向于非比例分配（信用法）。
<p></p>贷方质量平衡法的出发点是相同的：生产中使用的替代原料在加工过程中被混合，在系统中输入的确切数量经常随时间而波动。在贷方方法中，考虑到所有的损失和转换因素，在一个确定的时期内的投入被归于生产组织生产的特定产品。它允许要求记录的产出量等同于规定时期内的实际投入。由于投入只归属于特定的产出，该组织的某些产品被允许带有循环原料标签，而其他产品则不允许带有该标签。
    `,
    tooltips8: `
    消费后回收物是由家庭或商业、工业和机构设施产生的，他们作为产品的最终用户，不能再用于其预期目的。这包括从分销链中退回的材料。
    <p></p>。
    `,
    tooltips9: `
    质量平衡是一种保管链方法，用于说明进入和离开系统的材料。例如，在化学工业中，可再生或回收原料在连续操作的生产过程中与化石原料混合，并在发生化学转化后转化为特定的最终产品。输入和输出材料之间存在物理联系，这是现有认证方案的一个关键特征（与“账簿和索赔”相比也是如此）。
    <p></p>包括质量平衡在内的监管链模型的基本定义在ISO 22095标准中描述。一个额外的ISO标准正在制定中，其目标是描述更多的细节并澄清与 "账簿和索赔 "的确切区别（预计将在2025/2026年生效）。
    <p></p>关于分配，化工行业更倾向于非比例分配（信用法）。
    <p></p>贷方质量平衡法的出发点是相同的：生产中使用的替代原料在加工过程中被混合，在系统中输入的确切数量经常随时间而波动。在贷方方法中，考虑到所有的损失和转换因素，在一个确定的时期内的投入被归于生产组织生产的特定产品。它允许要求记录的产出量等同于规定时期内的实际投入。由于投入只归属于特定的产出，该组织的某些产品被允许带有循环原料标签，而其他产品则不允许带有该标签。
    `,
    tooltips10: `为了确保生产的材料符合某些标准，建立了不同的认证。例如，ISCC或RedCERT是可持续发展的认证系统，以保证原料和工艺符合规定的标准。根据具体要求，可以填入不同的子认证系统，如 "ISCC PLUS"。`,
    tooltips11: `要构成生物基材料，它必须具有生物来源。无机材料或地质构造中发现的材料（如金属）不能是生物基的。`,
    tooltips12: `由主要可再生原料（如天然橡胶、棉花、亚麻、甘蔗）制成的材料含量。`,
    tooltips13: `由废料或可再生原料的残留物制成的材料的含量（废食油（UCO），农业废料）。`,
    tooltips14: `为了确保生产的材料符合某些标准，建立了不同的认证。例如，ISCC或RedCERT是可持续发展的认证系统，以保证原料和工艺符合规定的标准。根据具体要求，可以选择不同的子认证系统，如 "ISCC PLUS"。下拉列表提供了一个基本方案的清单。如果您使用的认证体系没有被提及，请通知CAMDS系统管理人员，它将被添加到列表中。`,
  },
  EN: {
    //英文翻译
    title: "	Material",
    type: "	Type",
    cid: "	ID",
    cver: "	Version",
    enterprise: "Supplier ",
    cname: "Material Name ",
    cfrname: " Name(Foreign) ",
    csymbol: "	Material No.",
    ctradename: "	Trade name",
    class: "	Material classification",
    extraclass: "	Extra Material classification",
    cmatFlag: "Material code/Symbol",
    cmatFlagRefStd: "Norms/Standards",
    cinternalCode: "Material code",
    citnCodeStd: "Norms/Standards",
    creuseRate: "	Recyclability Rate",
    crecycleRate: "	Recoverability Rate",
    cremark: "	Remark",
    recycledmaterials: " recyclate",
    recycledmaterialsYes: " yes",
    recycledmaterialPostIndustrial:
      " Content of post-industrial/post-consumer recyclate",
    recycledmaterialMaxRate: " MaxRate",
    recycledmaterialConsumerrecyclate: " Content of post consumer recyclate",
    recycledmaterialMinRate: " MinRate",
    recycledmaterialRange: " recyclate ",
    recycledmaterialRISO: "  ISO 14021",
    recycledmaterialsNo: " No",
    recycledmaterialsTitle: " Does the material contain the recyclate?",
    recycledmaterialsTips:
      "Post-Industrial Recyclate that has been diverted from the waste stream during a manufacturing process. Excluded is reutilization of materials, such as rework, regrind or scrap generated in a process and capable of being reclaimed within the same process that generated it.",
    recycledmaterialsConsumerTips:
      "Post-Consumer Recyclate has been generated by households or by commercial, industrial and institutional facilities in their role as end-users of the product which can no longer be used for its intended purpose. This includes returns of material from the distribution chain.",
    sample: " Sample",
    checkReportNo: "Test Report No.",
    recycledmaterialsDna: "Not yet answered",
    recycleSourceEnterprise: " recycle Source Enterprise",
    createMaterial: "Creation of a new material",
    modifyMaterial: "Modify materials",
    msg: "Maybe this material already exists in CAMDS.If you are unsure about that, here you can jump to the material search.",
    msg1: "MDS with material classification 1.2/5.4/5.5.1/8.X is not available to convert to IMDS.",
    selectMaterClass: "Selection of the material classification",
    recycledMaterials1: "Does the material contain recyclate?",
    recycledMaterials2: "Mechanical (pre-consumer)",
    recycledMaterials3: "Mechanical (post-consumer)",
    recycledMaterials4: "Chemical (pre-consumer)",
    recycledMaterials5: "Chemical (post-consumer)",
    recycledMaterials6: "Certified according to",
    recycledMaterials7: "Is the material (partially) bio-based?",
    recycledMaterials8: "Content of secondary bio-based material",
    recycledMaterials9: "Certified according to",
    dRecycledMaterials1: "Source of material, including circular materials",
    dRecycledMaterials2: `All values entered here refer to the entire material, not only the polymer content. E.g., in case of filled polymers the recyclate content can only be 100% if the filler material is also 100% recyclate.`,
    dRecycledMaterials3: `Content of inorganic or fossil-based material`,
    dRecycledMaterials4: `Content of primary inorganic or fossil-based material`,
    dRecycledMaterials5: `Content of recyclate`,
    dRecycledMaterials5_1: `Content of mechanical recyclate thereof`,
    dRecycledMaterials5_1_1: `Content of pre-consumer recyclate thereof`,
    dRecycledMaterials5_1_2: `Content of post-consumer recyclate thereof`,
    dRecycledMaterials5_2: `Content of chemical recyclate thereof`,
    dRecycledMaterials5_2_1: `Content of pre-consumer recyclate thereof`,
    dRecycledMaterials5_2_2: `Content of post-consumer recyclate thereof`,
    dRecycledMaterials5_2_3: `Certified according to`,
    dRecycledMaterials5_2_4: `mass-balanced`,
    dRecycledMaterials5_2_5: `not mass-balanced`,
    dRecycledMaterials5_3: `Certified according to`,
    dRecycledMaterials6: `Content of bio-based material`,
    dRecycledMaterials6_1: `Content of primary bio-based material`,
    dRecycledMaterials6_2: `Content of secondary bio-based material`,
    dRecycledMaterials6_3: `Certified according to`,
    tooltips1: `Material content based on inorganic matter such as ores and minerals or fossil fuels (e.g., mineral oil)`,
    tooltips2: `This recycling technology recovers collected waste via mechanical and physical processes, typically sorting, grinding, washing, separating materials, drying, and re-crystallisation to produce material input which retains the chemical identity of the collected waste material.`,
    tooltips3: `
    Pre-Consumer Recyclate that has been diverted from the waste stream during a manufacturing process. Excluded is reutilization of materials, such as rework, regrind or scrap generated in a process and capable of being reclaimed within the same process that generated it.
    <p></p>
    `,
    tooltips4: `
    Post-Consumer Recyclate has been generated by households or by commercial, industrial and institutional facilities in their role as end-users of the product which can no longer be used for its intended purpose. This includes returns of material from the distribution chain.
    <p></p>
    `,
    tooltips5: `Conversion to monomer or production of new raw materials by changing the chemical structure of waste streams through cracking (pyrolysis), gasification or depolymerization, excluding energy recovery and incineration.`,
    tooltips6: `Pre-Consumer Recyclate that has been diverted from the waste stream during a manufacturing process. Excluded is reutilization of materials, such as rework, regrind or scrap generated in a process and capable of being reclaimed within the same process that generated it.
    <p></p>`,
    tooltips7: `
    Mass balance is a chain-of-custody approach to account for materials entering and leaving a system. In the chemical industry, e.g., renewable or recycled feedstock is mixed in a continuously operating production process with fossil-based feedstock and attributed to specific end products after chemical transformations have taken place. It is a key characteristic in existing certification schemes (also in comparison to "book and claim") that a physical link between input and output material exists.
    <p></p>The basic definitions of chain of custody models including Mass Balance are described in ISO 22095 standard. An additional ISO standard with the target to describe more details and clarify the exact distinction versus ‘book and claim’ is in development (expected to become valid 2025/2026).
    <p></p>Regarding allocation chemical industry prefers the non-proportional allocation (credit method).
    <p></p>The starting scenario in the credit mass balance method is the same: an alternative feedstock used in a production is mixed in processes and the exact amount fed in the system often fluctuates over time. In the credit method the input over a defined period is attributed to specific products that are produced by the production organization considering all losses and conversion factors. It allows to claim a recorded output amount equivalent to the physical input over a defined period. Due to the attribution of the input to only specific outputs, selected products of the organization are allowed to carry a circular raw material label, while others are not allowed to carry it.
    `,
    tooltips8: `
    Post-Consumer Recyclate has been generated by households or by commercial, industrial and institutional facilities in their role as end-users of the product which can no longer be used for its intended purpose. This includes returns of material from the distribution chain.
    <p></p>
    `,
    tooltips9: `
    Mass balance is a chain-of-custody approach to account for materials entering and leaving a system. In the chemical industry, e.g., renewable or recycled feedstock is mixed in a continuously operating production process with fossil-based feedstock and attributed to specific end products after chemical transformations have taken place. It is a key characteristic in existing certification schemes (also in comparison to "book and claim") that a physical link between input and output material exists.
    <p></p>The basic definitions of chain of custody models including Mass Balance are described in ISO 22095 standard. An additional ISO standard with the target to describe more details and clarify the exact distinction versus ‘book and claim’ is in development (expected to become valid 2025/2026).
    <p></p>Regarding allocation chemical industry prefers the non-proportional allocation (credit method).
    <p></p>The starting scenario in the credit mass balance method is the same: an alternative feedstock used in a production is mixed in processes and the exact amount fed in the system often fluctuates over time. In the credit method the input over a defined period is attributed to specific products that are produced by the production organization considering all losses and conversion factors. It allows to claim a recorded output amount equivalent to the physical input over a defined period. Due to the attribution of the input to only specific outputs, selected products of the organization are allowed to carry a circular raw material label, while others are not allowed to carry it.
    `,
    tooltips10: `
    To constitute a material as bio-based, it must be of biological origin. Inorganicized materials or materials found in geological formations (e.g., metals) cannot be bio-based.
    `,
    tooltips11:`To ensure that produced materials fulfill certain standards different certifications were established. For example, ISCC or RedCERT are sustainability certification systems to guarantee that feedstocks and processes fulfill defined criteria. Depending on the specific requirements different sub-certification system like "ISCC PLUS" can be chosen. The drop-down list provides a list of the basic schemes. In case the certification scheme you are using is not mentioned, please inform the CAMDS system administrator and it will be added to the list.`,
    tooltips12: `Content of material made from primary renewable raw materials (e.g., natural rubber, cotton, flax, sugar cane).`,
    tooltips13: `Content of material made from waste or residues of renewable raw materials (Used Cooking Oil (UCO), agricultural waste).`,
    tooltips14: `To ensure that produced materials fulfill certain standards different certifications were established. For example, ISCC or RedCERT are sustainability certification systems to guarantee that feedstocks and processes fulfill defined criteria. Depending on the specific requirements different sub-certification system like "ISCC PLUS" can be chosen. The drop-down list provides a list of the basic schemes. In case the certification scheme you are using is not mentioned, please inform the CAMDS system administrator and it will be added to the list.`,
  },
};
export default info; //需要暴露出去
